<template>
  <div class="youtaofang">
    <topTitle title="钱湖柏庭" :list="list" :newData="newData" :ContentStatus="ContentStatus" :remakTitle="remakTitle"></topTitle>
   
     <p v-html="dataContent" v-if="ContentStatus" class="content_p"></p>
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "项目简介",
          small_title: "PROJECT INTRODUCTION",
          hasTitle: "项目简介",
        },
        {
          title: "柏庭相册",
          small_title: "BOTING PHOTO ALBUM",
          hasTitle: "柏庭相册",
        },
        {
          title: "项目位置",
          small_title: "PROJECT LOCATION",
          hasTitle: "项目位置",
        },
        {
          title: "新闻中心",
          small_title: "NEW CENTER",
          hasTitle: "新闻中心",
          children: [
           
          ],
        },
      ],
      newData: 3,
      list2: [
        {
          img: require("../../assets/image/party/lvyou_1.png"),
        },
        {
          img: require("../../assets/image/party/lvyou_2.png"),
        },
        {
          img: require("../../assets/image/party/lvyou_3.png"),
        },
      ],
      dataContent:'',
      ContentStatus:false,
      remakTitle:'',
    };
  },
  methods: {
   
    getHtml(e){
       axios
        .get(
         
            "/api/article?id=" +
            e
        )
        .then((res) => {
       
          if(res.status=='200'){
            this.remakTitle=res.data.article.title;
            // this.list[this.newData].small_title='';

            this.ContentStatus=true;
            this.dataContent=res.data.article.content;
           
          }
         
        });
  
    }
  },
  mounted: function () {
        let number = this.$route.query.majorName;
      
        this.getHtml(number);
         //获取年
    var myDate = new Date();

    let YearList = myDate.getFullYear() - 2018;
    let year = [];
  
    for (let i = 0; i <= YearList; i++) {
      let arr = myDate.getFullYear() - i;
      let obj=new Object;
      obj.title=arr;
      obj.id=i;
      obj.option='0.1';
      obj.year=arr
      year.push(obj);
    }
 
    this.list[3].children=year
    //     this.$router.push({
    //     path: "/details",
    //     query: { majorName: e }
    //   });
  },
  destroyed: function () {
    this.$store.state.year = '';//存储年份
},
  components: {
    topTitle,
  },
  props: {
    
  },
};
</script>
<style scoped="scoped">
.content_p{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
p{
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
}
.content_p>>>img{
  width: 100%;
  height: 100%;
}
.youtaofang {
  width: 100%;
  height: 100%;
  text-align: left;
  overflow: hidden;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  margin-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_bd img {
  width: 4.0125rem;
  height: 3.0125rem;
  border-radius: 0.125rem;
}
.navGet{
  display: inline-block;
font-size: 32px;
font-family: PingFang SC;
font-weight: 500;
text-decoration: underline;
color: #3F674B;
line-height: 54px;
text-align: left;
margin-top: 0.6rem;
cursor: pointer;
}
</style>